import React from 'react';
import styled from 'styled-components';
import { Field } from 'redux-form';

import { ContentSet } from 'components/Shared/Scaffolding';
import { InputRow, Input, ColorPicker } from 'components/Shared/Forms';
import IconPicker from 'components/MarkerSettings/IconPicker';
import { BREAKPOINTS, SCAFFOLDING, SETTINGS_INPUTS } from 'theme';

const StyledContainer = styled(ContentSet)`
    padding: ${SCAFFOLDING.GUTTER_FACTOR(0.5)} ${SETTINGS_INPUTS.PADDING.X};
    background-color: ${SETTINGS_INPUTS.BG.SUB};
`;

const StyledInput = styled(Input)`
    @media (min-width: ${`${BREAKPOINTS.lg}px`}) and (max-width: ${`${BREAKPOINTS.xxl - 1}px`}) {
        width: calc(50% - ${SCAFFOLDING.GUTTER_FACTOR(0.25)});
    }
`;

const IconStyled = ({ color }) => (
    <StyledContainer>
        <Field label="Symbol" component={IconPicker} name="styledMarkerId" color={color} />
        <InputRow>
            <ColorPicker name="color" label="Color" />
            <StyledInput label="Size" name="size" type="int" required min={0} unitAfter="px" />
        </InputRow>
    </StyledContainer>
);

export default IconStyled;
